export const stepLayoutTarget = (ejercicio) => {
	let content1 = 
	(ejercicio == 'ejercicio-1' || ejercicio == 'ejercicio-3') ? 
	`Te damos la Bienvenida al curso para Creación de Aportaciones de Volumen en el sistema AMS.<br><br>
	El objetivo del curso es que los asociados refuercen la carga correcta de aportaciones a través 
	de una serie de ejercicios que te ayudarán a conocer la aplicación del sistema.<br><br>
	Para mostrar u ocultar el panel de instrucciones solo debes dar clic en esta pestaña.`:
	'Para mostrar u ocultar el panel de instrucciones solo debes dar clic en esta pestaña';

	return [{
		target: '[data-v-step="1"]',
		content: content1,
		params: {
			placement: 'left'
		}
	},
	{
		target: '[data-v-step="2"]',
		content: `En la página inicial de AMS, utiliza el menú de navegación y haz clic en Crear 
		Nuevo/Copiar para ir a la pantalla del Tipo de Acuerdo.`,
		params: {
			placement: 'right'
		}
	}];
}

export const stepOneTarget = 
[{
	target: '[data-v-step="3"]',
	content: `Selecciona Nueva solicitud para crear una nueva solicitud de acuerdo.`,
	params: {
		placement: 'right'
	}
},
{
	target: '[data-v-step="4"]',
	content: `Selecciona Volumen para crear un acuerdo de volumen.`,
	params: {
		placement: 'right'
	}
},
{
	target: '[data-v-step="5"]',
	content: `Haz clic en Continuar para ir a la pantalla de Información General.`,
	params: {
		placement: 'right'
	}
}];

export const stepStepsTarget = 
[{
	target: '[data-v-step="6"]',
	content: `En la pantalla de Información General, al seleccionar el País, los campos 
	Organización de Compras y Grupo de Compras se actualizan de forma predeterminada.`,
	params: {
		placement: 'right'
	}
}];

export const stepTwoTarget = (tienda) => {
	// let content17 = (tienda == 'autoservicio') ? 
	// `En una aportación por volumen, al capturar al pagador, se debe borrar 
	// el pagador que se puso por defecto, es necesario seleccionar el proveedor host a 
	// 6 dígitos y <strong>NO</strong> el número que contiene el departamento y el secuencial, 
	// ya que esto ocasionaría un error en la carga de la aportación, y el sistema podría duplicar 
	// el cobro o hacer un mal cobro al proveedor.`:
	// `Es necesario seleccionar el proveedor host a 6 dígitos`;

	let content17 = `Es necesario seleccionar el proveedor host a 6 dígitos`;



	let content16 = (tienda == 'autoservicio') ? 
	`Si deseas que una aportación de volumen sea sólo para un formato de negocio especifico:<br>
	<ul>
	<li>-Supercenter</li>
	<li>-Bodega</li>
	<li>-Mi Bodega y Bodega Aurrera Express</li>
	<li>-Superama</li>
	</ul>
	Deberás capturarlo con el número SAP de proveedor que le corresponde al HOST de 9 dígitos.<br><br>
	Ejemplo:<br>
	El proveedor Nº 388400 se dio de alta en el departamento 90 con secuencia 4, por lo tanto su número a 9 dígitos es 3884009004<br><br>
	<strong>388400 (No. De Proveedor) +90 (Departamento) +4 (Secuencial de Superama) = 388400904</strong><br><br>
	<table style="width:100%">
	<tr style="border-bottom: 1px solid;">
		<td style="font-weight: bold;text-align:center;">#SAP<br> Proveedor</td>
		<td style="text-align:center;">Nº Proveedor HOST<br> a 9 dígitos</td>
		<td style="text-align:center;">Razón Social</td>
	</tr>
	<tr>
		<td style="font-weight: bold;text-align:center;">1000235689</td>
		<td style="text-align:center;">388400904</td>
		<td style="text-align:center;">SUGAR FOODS DE MEXICO S DE RL DE CV</td>
	</tr>
	</table>`:`El proveedor SAP debe coincidir con el vendor a 6 dígitos`;
return [{
	target: '[data-v-step="7"]',
	content: `La Descripción de solicitud de acuerdo se completa automáticamente según 
	la selección del usuario del Tipo de Acuerdo.<br> En este caso, será «Acuerdo de Volumen".`,
	params: {
		placement: 'right'
	}
},
{
	target: '[data-v-step="8"]',
	content: `En el campo Válido desde fecha, ingresa la fecha de inicio del evento del acuerdo.`,
	params: {
		placement: 'bottom'
	}
},
{
	target: '[data-v-step="9"]',
	content: `En el campo Válido hasta fecha, ingresa la fecha de finalización del evento del acuerdo.`,
	params: {
		placement: 'bottom'
	}
},
{
	target: '[data-v-step="10"]',
	content: `Selecciona el Tipo de Locación haciendo clic en el ícono búsqueda.`,
	params: {
		placement: 'right'
	}
},
{
	target: '[data-v-step="11"]',
	content: `Haz clic en la casilla de verificación de Auto renovación de acuerdo, 
	si es necesario (si no se selecciona esta opción no se podrá auto renovar posteriormente).`,
	params: {
		placement: 'left'
	}
},
{
	target: '[data-v-step="12"]',
	content: `El sistema tiene como principal método de pago Neteo, 
	al utilizar No Neteo Bloquea Pagos a Proveedor.`,
	params: {
		placement: 'right'
	}
},
{
	target: '[data-v-step="13"]',
	content: `Selecciona el tipo de Moneda, ya sea local o extranjera.`,
	params: {
		placement: 'left'
	}
},
{
	target: '[data-v-step="14"]',
	content: `<strong>Calendario Mensual:</strong><br> El sistema genera al proveedor un documento de descuento el último día de mes.<br><br>
			  <strong>Calendario Diario:</strong><br> El sistema genera al proveedor un documento de descuesto  diario.`,
	params: {
		placement: 'right'
	}
},
{
	target: '[data-v-step="15"]',
	content: `Selecciona los Términos de Pago.`,
	params: {
		placement: 'left'
	}
},
{
	target: '[data-v-step="16"]',
	content: content16,
	params: {
		placement: 'right'
	}
},
{
	target: '[data-v-step="17"]',
	content: content17,
	params: {
		placement: 'left'
	}
},
{
	target: '[data-v-step="18"]',
	content: `Verifica los datos ingresados en la pantalla de Información General y 
	haz clic en Continuar para pasar a la pantalla de Aportaciones y guardar los datos capturados.`,
	params: {
		placement: 'right'
	}
}]

};


export const stepThreeTarget = (tienda) => {
	let content29 = (tienda == 'autoservicio') ? 
		`<strong>AUTOSERVICIO:</strong> <br>Para la selección de formato, debes ingresar los negocios con base en el Tipo de Ubicación Retail 100001 (Autoservicio) .<br><br> 
		Y para el Formato de distribución debes de seleccionar Tipo ubicación 100013, Cod Banner: 101051 DISTRIBUTION`:
		`<strong>CLUB DE PRECIOS:</strong> <br>Para la selección de formato, debes ingresar los 
		negocios con base en el Tipo de Ubicación Retail 100017 (SAM’S) .<br><br> 
		Y para el Formato de distribución, debes de seleccionar Tipo ubicación 100019, Cod Banner 101051 DISTRIBUTION`;

	let content30 = (tienda == 'autoservicio') ? 
					`<strong>AUTOSERVICIO:</strong><br>La distribución del monto de la aportación puede ser a Total Tiendas o a tiendas en específico.`:
					`<strong>SAM´S:</strong><br>La distribución del monto de la aportación puede ser a Total Club o a Clubs en específico.`

	return [{
		target: '[data-v-step="19"]',
		content: `Selecciona el Tipo de Aportación del menú desplegable.`,
		params: {
			placement: 'right'
		}
	},
	{
		target: '[data-v-step="20"]',
		content: `El campo Descripción de Aportación se rellena previamente con 
		el tipo de aportación seleccionado. Sin embargo, este campo es editable. 
		Puedes introducir una descripción de aportación personalizada, si es necesario.`,
		params: {
			placement: 'right'
		}
	},
	{
		target: '[data-v-step="21"]',
		content: `Los campos de Válido desde y Válido hasta se llenan automáticamente con base en la información general.`,
		params: {
			placement: 'right'
		}
	},
	{
		target: '[data-v-step="22"]',
		content: `Selecciona la Base de Cálculo del menú desplegable. Puedes escoger POS (Venta) 
		o Recepción (Compra).`,
		params: {
			placement: 'right'
		}
	},
	{
		target: '[data-v-step="23"]',
		content: `Cuando se selecciona la opción Recepción, se activa automáticamente la opción de seleccionar 
		el Tipo de Devolución en el cual se puede incluir o no.`,
		params: {
			placement: 'right'
		}
	},
	{
		target: '[data-v-step="48"]',
		content: `Debes dar clic en <strong>"<i>Nueva línea</i>"</strong> para ingresar tu aportación.`,
		params: {
			placement: 'bottom'
		}
	},
	{
		target: '[data-v-step="41"]',
		content: `La Opción auto agregar Artículos no es editable, esta opción se selecciona 
		automáticamente para aquellos  Acuerdos de Volumen  que son ingresados a Total Depto o fineline. 
		Esta opción agregará todos los artículos nuevos que se den de alta durante la vigencia del acuerdo.`,
		params: {
			placement: 'bottom'
		}
	},
	{
		target: '[data-v-step="45"]',
		content: `Grupo de artículos: El cálculo se realiza con base en la suma del total de los 
		artículos ingresados en la aportación.<br><br>
		Artículos individuales: El cálculo se realiza con base en cada artículo ingresado en la aportación.`,
		params: {
			placement: 'right'
		}
	},
	{
		target: '[data-v-step="24"]',
		content: `Con base en la negociación que realices deberás seleccionar los niveles. Ejemplo. 
		Si la negociación es un porcentaje por volumen recuerda que debes seleccionar monto, el tipo de 
		tarifa debe ser porcentual, tipo de escala, escalonado. Si no seleccionas correctamente los rubros, 
		el cobro lo hará de manera incorrecta.`,
		params: {
			placement: 'bottom'
		}
	},
	{
		target: '[data-v-step="44"]',
		content: `Escalonado son las transacciones que se calculan con base al número de niveles que ingreses en la negociación.<br><br>Walmart México maneja tipo escalonado.`,
		params: {
			placement: 'bottom'
		}
	},
	{
		target: '[data-v-step="47"]',
		content: `Debes dar clic en <strong>"<i>Nuevo Nivel</i>"</strong> para ingresar los límites de la aportación.`,
		params: {
			placement: 'top'
		}
	},
	{
		target: '[data-v-step="25"]',
		content: `Ingresa el límite inferior del nivel en el campo Valor Desde. Si este es el primer nivel, el valor siempre será 0.`,
		params: {
			placement: 'top'
		}
	},
	{
		target: '[data-v-step="26"]',
		content: `Ingresa el límite superior del nivel en el campo Valor Hasta. El valor por default es 99,999,999,999.`,
		params: {
			placement: 'top'
		}
	},
	{
		target: '[data-v-step="27"]',
		content: `La tarifa es con base al monto, porcentaje o cantidad que se haya negociado.`,
		params: {
			placement: 'top'
		}
	},
	{
		target: '[data-v-step="28"]',
		content: `El campo de Región no aplica para México.`,
		params: {
			placement: 'right'
		}
	},
	{
		target: '[data-v-step="29"]',
		content: content29,
		params: {
			placement: 'right'
		}
	},
	{
		target: '[data-v-step="30"]',
		content: content30,
		params: {
			placement: 'right'
		}
	},
	{
		target: '[data-v-step="31"]',
		content: `Haz clic en Guardar Aportación para guardar los cambios. Una vez guardado, 
		se añadirá a la tabla de Aportaciones Guardadas Actuales, situada debajo de la sección de Selección de Tiendas.`,
		params: {
			placement: 'right'
		}
	},
	{
		target: '[data-v-step="46"]',
		content: `Recuerda que puedes agregar otros acuerdos en el mismo folio de solicitud, 
		éste debe ser para el mismo proveedor SAP.`,
		params: {
			placement: 'right'
		}
	},
	{
		target: '[data-v-step="32"]',
		content: `Verifica los datos ingresados en la pantalla de Aportaciones y haz clic en 
		Continuar para pasar a la pantalla de Aprobadores.`,
		params: {
			placement: 'right'
		}
	}]
};


export const stepFourTarget = 
[{
	target: '[data-v-step="33"]',
	content: `Selecciona el ID del usuario de cada uno de los aprobadores haciendo clic 
	en el ícono de búsqueda. El Primer Nombre y el Apellido se actualizan de forma predeterminada.`,
	params: {
		placement: 'right'
	}
},
{
	target: '[data-v-step="34"]',
	content: `Ingresa el número de usuario del proveedor de Retail Link.`,
	params: {
		placement: 'right'
	}
},
{
	target: '[data-v-step="35"]',
	content: `Si un proveedor se encuentra dado de alta en Retail link, tendrá la posibilidad de 
	autorizar electrónicamente las aportaciones que ingreses en AMS.
	<br><br>Para permitir capturar manualmente al proveedor, es necesario deshabilitar esta opción.`,
	params: {
		placement: 'bottom'
	}
},
{
	target: '[data-v-step="36"]',
	content: `Verifica los datos introducidos en la pantalla de Aprobadores y haz clic en 
	Continuar para pasar a la pantalla de Archivos Adjuntos.`,
	params: {
		placement: 'right'
	}
}];


export const stepFiveTarget = 
[{
	target: '[data-v-step="37"]',
	content: `Para los acuerdos de volumen debes adjuntar los documentos que avalen la negociación pactada:<br><br>
	-Fomato V2<br>
	-Adendum<br>
	-Correo donde se explique <br>detalladamente la negociación.<br><br>
	Recuerda que el nombre de los archivos no debe exceder de los 40 caracteres.`,
	params: {
		placement: 'right'
	}
},
{
	target: '[data-v-step="39"]',
	content: `Los comentarios deben ser claros y respaldar la aportación:<br><br>
	-Indicar periodo de validez y tipo de aportación<br>
	-Indicar cómo y de dónde se obtuvieron los fondos<br><br>
	En caso de periodos anteriores, justificar la captura tardía.`,
	params: {
		placement: 'top'
	}
},
{
	target: '[data-v-step="40"]',
	content: `Después de introducir todos los datos necesarios, haz clic en Guardar para pasar a la pantalla de Finalizar.`,
	params: {
		placement: 'right'
	}
}];

export const stepSixTarget = [
{
	target: '[data-v-step="49"]',
	content: `Debes dar clic en <strong>"<i>Enviar para aprobación</i>"</strong> 
	para terminar el proceso de captura.`,
	params: {
		placement: 'right'
	}
},
{
	target: '[data-v-step="42"]',
	content: `Para concluir este ejercicio, da clic en este botón.`,
	params: {
		placement: 'right'
	}
}
];